<dx-popup #popupEmailFax class="popup" [width]="310" [height]="150" [showTitle]="true" [dragEnabled]="true"
          [closeOnOutsideClick]="false" [showCloseButton]="false" [(visible)]="popupVisible" (onTitleRendered)="onTitleRendered($event)">
    <dxi-toolbar-item location="before">
        <h3 style="margin: 2px 10px">Update Bill To</h3>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Send" (click)="save()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" style="height: 100%">
        <dx-scroll-view [showScrollbar]="'onScroll'">
            <form style="height: 100%">
                <div class="content-block" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <app-bill-to-type [defaultValue]="'INSURANCE'" (selection)="billTypeChanged($event)"></app-bill-to-type>
                </div>
            </form>
        </dx-scroll-view>
    </div>
</dx-popup>
<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>

